
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Tooltip, Popover, Avatar, Input, Button, Tag } from 'antd';
import { BrowserRouter as Router1, HashRouter as Router, Route, Link, Redirect, useHistory } from "react-router-dom";
import SubMenu from 'antd/lib/menu/SubMenu';
import { UserPages } from '@gtpl/pages/user-management/user-management-pages/user-pages';
import SupplierMappingForm from 'libs/pages/master/master-components/supplier-mapping/src/lib/supplier-mapping';
import SupplierMappingGrid from 'libs/pages/master/master-components/supplier-mapping/src/lib/supplier-mapping-grid';

export const UsersRouting = () =>{
    return(
        <>
   <Route exact path="/user-grid" component={UserPages} />
   <Route exact path="/supplier-creation" component={SupplierMappingForm} />
   <Route exact path="/supplier-creation-grid" component={SupplierMappingGrid} />

        </>
    )
}
export default UsersRouting
